module.exports = "<main class=\"container\">\n  <h1 class=\"visuallyHidden\">{{title}}</h1>\n  <donate-banner [balance]=\"balance\"></donate-banner>\n  <donate-form [donors]=\"donors\" [progress]=\"progress\" (submit)=\"submit($event)\" (save)=\"save($event)\"></donate-form>\n\n  <!-- <a class=\"github\" href=\"https://github.com/CreativeBrandon/donate\">\n    <img src=\"./assets/github.png\" alt=\"github\" /> View on github\n  </a> -->\n</main>"


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/donate/donate.component.html
// module id = ../../../../../src/app/main/donate/donate.component.html
// module chunks = main